











import { Component, Vue } from 'vue-property-decorator'
import { chain } from 'lodash'
import RoutineList from '@/components/RoutineList.vue'

@Component({
  components: { RoutineList }
})
export default class RoutineFinder extends Vue {
  get routines () {
    return chain(this.$store.getters['routines/all'])
      .filter((routine) => routine.circuits && !!routine.circuits.length)
      .sortBy('name.en')
      .value()
  }

  navigateBack () {
    this.$router.push({ name: 'dashboard' })
  }
}
